import React from "react";
import { formatCompletionRatio } from "../../../formatUtils";
import { STRINGS } from "../../../strings";
import { TrainingCenterCaregiverBundle } from "../../../system/AppState/AppStateTrainingCenter";
import { translate } from "../../../translate";
import { formatDuration } from "../../../utils/dateUtils";
import { fmap } from "../../../utils/fmap";
import { CHECK_ICON, PLAY_ICON } from "../../../utils/svgs_new";
import { AppIcon } from "../../Generic/AppIcon";
import { TrainingCenterLanguagePreference } from "../../TrainingCenter/TrainingCenterLanguageLookup";
import {
  formatReadableRelativeDueDate,
  getDisplayData,
  getTrainingCenterBundleCompletionRatio,
  getTraningCenterBundleDuration,
  isTrainingCenterBundleCompleted,
  lookupBundleThumbnailUrl,
} from "../../TrainingCenter/TrainingCenterUtils";

interface Props {
  bundle: TrainingCenterCaregiverBundle;
  languagePreference: TrainingCenterLanguagePreference;
}

const TrainingCenterBundleCardBanner = (props: Props) => {
  const isCompleted = isTrainingCenterBundleCompleted(props.bundle);
  const duration = getTraningCenterBundleDuration(props.bundle.bundleItems);
  const completionRatio = getTrainingCenterBundleCompletionRatio(props.bundle.bundleItems);
  const displayData = getDisplayData(props.bundle.bundleDisplayData, props.languagePreference);
  const thumbnailUrl = lookupBundleThumbnailUrl(props.languagePreference, props.bundle);
  const readableDueDate = formatReadableRelativeDueDate(props.bundle);

  return (
    <div className="TrainingCenterBundleCardBanner" data-is-completed={isCompleted}>
      <div className="bundle-banner-top">
        {isCompleted ? (
          <>
            <div className="bundle-banner-completed">{translate(STRINGS.COMPLETED)}!</div>

            <div className="bundle-banner-complete-icon">
              <AppIcon icon={CHECK_ICON} size={12} />
            </div>
          </>
        ) : (
          <>
            {props.bundle.showDuration ? (
              <div className="bundle-banner-duration">{formatDuration(duration)}</div>
            ) : null}

            <div className="bundle-banner-completion">{formatCompletionRatio(completionRatio)}</div>

            <div className="bundle-banner-play-icon">
              <AppIcon icon={PLAY_ICON} size={12} />
            </div>
          </>
        )}
      </div>

      <div className="bundle-banner-bottom">
        <div className="bundle-banner-due-date">{readableDueDate}</div>

        <div className="bundle-banner-title">{displayData.data.title}</div>
      </div>

      <div
        className="bundle-banner-background"
        style={{
          ["--thumbnail-url" as any]: fmap(thumbnailUrl, (x) => `url("${x}")`),
        }}
      />
    </div>
  );
};

export default TrainingCenterBundleCardBanner;
